<template lang="pug">
  div
    v-card.pa-6.mt-4.round-xl(outlined)
      .d-flex.align-center.justify-space-between
        div
          .d-flex.align-center
            div.text-md.font-semibold.neutral700--text.mr-2 Connect to checkout
            v-sheet.round-md(color="#E0EFFF")
              .d-flex.align-center.pa-1
                v-icon.mr-1(size="10" color="#0C6DFF") $yzi-zap
                .text-xxs(style="color: #0C6DFF") Premium
          .text-sm.neutral700--text(style="margin-top: 2px;") Access offers during customer checkout process
        v-btn.button-sm(outlined @click="handleUpgradeFeature") Upgrade
    .dialogs
      upgrade-feature-dialog(v-if="openUpgradeFeatureDialog" :open.sync="openUpgradeFeatureDialog" :loading="isLoading" @submit="handleSubmit")
</template>

<script>
import UpgradeFeatureDialog from "@/components/clinic/marketing/dialogs/UpgradeFeatureDialog.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    UpgradeFeatureDialog
  },
  data() {
    return {
      isLoading: false,
      openUpgradeFeatureDialog: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    handleUpgradeFeature() {
      this.openUpgradeFeatureDialog = true
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        const url = `/marketing/${this.company.slug}/connect_to_checkout`
        const {data} = await this.$axios.post(url)
        this.updateActivityLog(url, null, data, 'POST')
        this.openUpgradeFeatureDialog = false
      } catch (e) {
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateActivityLog(endpoint, payload, response, method) {
      let data = {
        company: this.company.id,
        object_id: null,
        object_ref: 'connect_to_checkout',
        activity: 'Request to connect to checkout via marketing dashboard',
        raw_data: {endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {
          })
    }
  },
}
</script>

<style scoped>
</style>